import request from '@helpers/request';

const baseUrl = '/v1/gis';
function Post(address, params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ 'Content-Type': 'application/json' })
    .build()
    .post(`${baseUrl}${address}`, params, { ...config });
}
function Get(address, config) {
  return request
    .forBaseUrl()
    .withHeaders({ 'Content-Type': 'application/json' })
    .build()
    .get(`${baseUrl}${address}`, { ...config });
}

function Delete(address, config) {
  return request
    .forBaseUrl()
    .withHeaders({ 'Content-Type': 'application/json' })
    .build()
    .delete(`${baseUrl}${address}`, { ...config });
}

const gisservice = {
  Get,
  Post,
  Delete,
};

export default gisservice;
